module.exports = __webpack_public_path__ + "static/media/dualAdultBlock.b0f680f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/dualAdultBlock.png
// module id = 598
// module chunks = 0